import fetchSalon from 'actions/fetchSalon.action';
import listSalons from 'actions/listSalons.action';
import postPin from 'actions/pin/postPin.action';
import selectLockEnabled from 'selectors/selectLockEnabled';
import selectSupportedSalons from 'selectors/selectSupportedSalons';
import { selectHasLockToken } from 'selectors/simple';
import dispatch from 'utils/core/dispatch.util';
import getState from 'utils/core/getState.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import { isNotValidId } from 'utils/predicates/fields.util';
import checkSupportSalon from 'utils/salons/checkSupportSalon';

const L = logger('refreshLockToken');

const fetchLockEnabled = async ({ salonId }) => {
  if (isNotValidId(salonId)) {
    L.warn('fetchLockEnabled()', 'Invalid salonId:', salonId);
  }

  // null means there is no data from BE, do the necessary fetches
  if (selectLockEnabled(getState()) === null) {
    // the reducers are supposed to fill in the data after the fetch finishes
    await dispatch(fetchSalon(salonId));
  }

  return selectLockEnabled(getState());
};

const fetchSupportSalons = async () => {
  const supportSalons = selectSupportedSalons(getState());

  if (supportSalons) {
    return supportSalons;
  }

  // the reducers are supposed to fill in the data after the fetch finishes
  await dispatch(listSalons());

  return selectSupportedSalons(getState());
};

const refreshLockToken = async (options) => {
  try {
    const { salonId, pin, force } = asObject(options);

    if (force) {
      return await dispatch(postPin({ salonId, pin }));
    }

    const salons = L.debug('()', 'salons:', await fetchSupportSalons());
    const isSupport = checkSupportSalon({ salons, salonId });
    if (isSupport) {
      // customer support users don't get lock screen, so they must get a token without pin
      return await dispatch(postPin({ salonId }));
    }

    const isLockEnabled = L.debug('()', 'isLockEnabled:', await fetchLockEnabled({ salonId }));
    const hasToken = L.debug('()', 'hasToken:', selectHasLockToken(getState()));
    if (!hasToken || isLockEnabled !== true) {
      return await dispatch(postPin({ salonId, pin }));
    }

    return void L.warn('()', 'Did not post pin because:', { salonId, isSupport, hasToken, isLockEnabled, salons });
  } catch (e) {
    throw L.warn('()', e);
  }
};

// noinspection JSUnusedGlobalSymbols
export default refreshLockToken;
